// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"a9f8fcea","850":"decec902"}[chunkId] + ".chunk.js";
};